import { gql } from "apollo-boost"

export const CREATE_LOCKED_ASSISTANCE_DATES = gql`
  mutation createLockedAssistanceDates(
    $submissionId: ID!,
    $lockedAssistanceDates: [LockedAssistanceDateInput!]!
  ) {
    CreateLockedAssistanceDates(
      submissionId: $submissionId
      lockedAssistanceDates: $lockedAssistanceDates
    ) {
      year
      month
      lockAllActivities
      lockedActivities
      allowedActivities
    }
  }
`
